export default __webpack_public_path__ + "static/media/galarie8.14fdf7b3.jpg";